import { call, put, select, takeLatest, } from 'redux-saga/effects';

import { fetchCheckoutTerms as actions, } from './actions';
import * as types from './types';
import { repositories, } from 'api'
import { getChartToken, } from 'common/selectors';

export {
    actions,
};

const checkoutTerms = new repositories.CheckoutTerms();

function* fetchCheckoutTerms() {
    try {
        const token = yield select(getChartToken);

        const { data, } = yield call([ checkoutTerms, 'getAll', ], token);

        yield put(actions.success(data));
    } catch (error) {}
}

function* checkoutTermsSaga() {
    yield takeLatest(types.FETCH_CHECKOUT_TERMS_REQUEST, fetchCheckoutTerms);
}

export default checkoutTermsSaga;
